package com.ustadmobile.core.account

class UnauthorizedException(message: String? = null, cause: Throwable? = null): IllegalStateException(message, cause) {
}